import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { BiCheck } from "react-icons/bi";
import { setAppError } from "../../../../store/userSlice";
import { axios } from "../../../../Global";
import { checkAccessFn } from "../../../../utils/checkAccess";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";

export default function ListProfession({
  professions = [],
  setProfessions,
  editData,
  deleteData,
  loading,
  titles = [],
  rowEditing,
  setRowEditing,
  addData,
  listLoading,
}) {
  const [actualState, setActualState] = useState("");
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    CountPerPage,
    Search,
    currentList,
  } = useSearchPagination(professions);

  const handleEdit = (event, id) => {
    setProfessions((prevProfessions) =>
      prevProfessions?.map((profession) =>
        profession.id === id
          ? { ...profession, name: event.target.value.toUpperCase() }
          : profession
      )
    );
  };

  const editSave = async (updatedProfession) => {
    if (actualState === updatedProfession.name) return setRowEditing({});
    try {
      await axios.put(
        `/dashboard/visa-profession/${updatedProfession.id}`,
        updatedProfession,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(setAppError({ msg: "Edited successfully", color: "success" }));
      setRowEditing({});
    } catch (error) {
      setRowEditing({});
      dispatch(setAppError({ msg: error.message }));
    }
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);
  const [searchWords, setSearchWords] = useState([]);
  return (
    <div className="pt-2 uppercase">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        {checkAccess("VISA / IQAMA PROFESSION", "visa-iqama-profession-create") &&
          (!rowEditing.id ? (
            <Link to="/dashboard/visa-profession/create">
              <button
                className="p-2 bg-red uppercase text-white rounded-md"
                onClick={addData}
              >
                Add New Visa Profession +
              </button>
            </Link>
          ) : (
            <button
              className="p-2 uppercase bg-rose-200 text-white rounded-md"
              onClick={() =>
                dispatch(setAppError({ msg: "Complete the edit." }))
              }
            >
              Add New Visa Profession +
            </button>
          ))}
        <Search searchKey={["name"]} setSearchWords={setSearchWords} />
        <CountPerPage />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1 md:hidden block">{`Slide / scroll to right >`}</p>
      <div
        className={`grid grid-cols-table-3 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {listLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-3">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!listLoading && <NoDataFound />}

        {!listLoading &&
          currentList.map((list, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />

              {rowEditing?.id !== list.id && (
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.name || "-"}
                />
              )}
              {rowEditing?.id == list.id && (
                <textarea
                  rows={1}
                  type="text"
                  className={`${
                    rowEditing?.id === list.id && "outline outline-1"
                  }  w-full p-1 rounded uppercase`}
                  defaultValue={list.name}
                  onChange={(event) => handleEdit(event, list.id)}
                  disabled={rowEditing?.id !== list.id}
                />
              )}

              <div className="flex gap-3 min-w-fit ">
                {checkAccess(
                  "VISA / IQAMA PROFESSION",
                  "visa-iqama-profession-edit"
                ) ? (
                  rowEditing?.id && rowEditing?.id === list.id ? (
                    <button
                      className={
                        listLoading || currentList?.length <= 0
                          ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                          : "p-1 px-2 rounded-md ring-1 ring-slate-600"
                      }
                      onClick={() => editSave(list)}
                      disabled={
                        loading.edit || listLoading || currentList?.length <= 0
                      }
                    >
                      {loading.edit && loading.loadingId === list.id ? (
                        <CgSpinner className="animate-spin mx-auto" />
                      ) : (
                        <BiCheck className="text-xl" />
                      )}
                    </button>
                  ) : (
                    <button
                      className={`p-1 px-2 rounded-md ring-1 ring-slate-600 ${
                        rowEditing?.id ||
                        listLoading ||
                        (currentList?.length <= 0 && "cursor-not-allowed")
                      }`}
                      onClick={() => {
                        setActualState(list.name);
                        setRowEditing({ id: list.id, method: "edit" });
                      }}
                      disabled={
                        loading.edit ||
                        rowEditing?.id ||
                        listLoading ||
                        currentList?.length <= 0
                      }
                    >
                      {loading.edit && loading.loadingId === list.id ? (
                        <CgSpinner className="animate-spin mx-auto" />
                      ) : (
                        <CiEdit size={"1.4rem"} />
                      )}
                    </button>
                  )
                ) : (
                  <button className={`p-1 px-2 rounded-md ring-1`} disabled>
                    --
                  </button>
                )}

                {checkAccess(
                  "VISA / IQAMA PROFESSION",
                  "visa-iqama-profession-delete"
                ) ? (
                  <button
                    className={`p-1 px-2 rounded-md ring-1 ring-red text-white bg-red ${
                      rowEditing?.id ||
                      listLoading ||
                      (currentList?.length <= 0 && "cursor-not-allowed")
                    }`}
                    onClick={() =>
                      deleteData((oldState) => ({ open: true, id: list.id }))
                    }
                    disabled={
                      loading.delete ||
                      rowEditing?.id ||
                      listLoading ||
                      currentList?.length <= 0
                    }
                  >
                    {loading.delete && loading.loadingId === list.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <MdDeleteOutline size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <button className={`p-1 px-2 rounded-md ring-1`} disabled>
                    --
                  </button>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-3 `}
              />
            </React.Fragment>
          ))}
      </div>
      <Pagination />
    </div>
  );
}
